var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unsupportedBrowserMsg"},[_c('div',{staticClass:"unsupportedBrowserMsg__content-wrapper"},[_vm._v("\n      "+_vm._s(_vm.$t("unsupportedBrowserMsg"))+"\n")])])
}
var staticRenderFns = []

export { render, staticRenderFns }